import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getPermissions = store => store[NAME].permissions;
export const getTypes = store => store[NAME].types;
